import { takeLatest, call, put } from 'redux-saga/effects';
import {
  signInRequest,
  signInSuccess,
  error,
  meRequest,
  meSuccess,
  initialLoadRequest,
  initialLoadSuccess,
  initialLoadUnauthenticated,
  logoutRequest,
  logoutSuccess,
} from '../../ducks/UserDucks';
import history from '../../../utils/history';
import { portalLanding } from '../../../services/PortalAccess';
import Authentication from '../../../utils/authentication';
import { enqueueSnackbar } from '../../ducks/SnackbarDucks';

function* signIn(action) {
  try {
    const { email, password } = action.payload;
    yield call(Authentication.login, email, password);
    const profile = yield call(Authentication.getProfile);
    // Establish the route while private consumers are still loading.
    history.replace(portalLanding(profile));
    yield put(
      signInSuccess({
        user: profile,
      })
    );
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({ message: err.message }));
    yield call(Authentication.logout);
  }
}

function* fetchUser() {
  try {
    const profile = yield call(Authentication.getProfile);
    if (history.location?.pathname === '/login') history.replace(portalLanding(profile));
    yield put(
      meSuccess({
        user: profile,
      })
    );
  } catch (err) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        },
      })
    );
    yield put(error({ message: err.message }));

    yield call(Authentication.logout);
  }
}

function* signOut(action) {
  const message = yield call(Authentication.logout, action.payload);
  yield put(logoutSuccess());
  if (message) {
    yield put(enqueueSnackbar(message));
  }
}

function* initialUserLoad() {
  try {
    const token = yield call(Authentication.getToken);
    if (!token) return yield put(initialLoadUnauthenticated());
    const profile = yield call(Authentication.getProfile);
    if (history.location?.pathname === '/login') history.replace(portalLanding(profile));
    yield put(
      initialLoadSuccess({
        user: profile,
      })
    );
  } catch (err) {
    yield put(error({ message: err.message }));
  }
}

export default function* watchUser() {
  // A newer account operation also cancels older profile establishment.
  yield takeLatest(
    [signInRequest.type, logoutRequest.type, meRequest.type, initialLoadRequest.type],
    function* (action) {
      const handlers = {
        [signInRequest.type]: signIn,
        [logoutRequest.type]: signOut,
        [meRequest.type]: fetchUser,
        [initialLoadRequest.type]: initialUserLoad,
      };
      yield call(handlers[action.type], action);
    }
  );
}
